var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rotateBox"},[_c('div',[_c('span',{staticClass:"rotate",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }